import { PAGE_CONTAINER_MAX_WIDTH, PageContainerRoot } from './page-container';
import { PageContainerVariantProps } from './page-container.types';

/** Width-constrained, horizontally centered content column. */
export const Centered = (props: PageContainerVariantProps) => (
  <PageContainerRoot maxWidth={PAGE_CONTAINER_MAX_WIDTH} {...props} />
);

Centered.displayName = 'PageContainer.Centered';
